export default class Office {
    public name : string = '';
    public street : string = '';
    public houseNumber : string = '';
    public postalCode : string = '';
    public city : string = '';
    public openingHours : string = '';
    public telephone : string = '';
    public email : string = '';
    public latitude : number = 0;
    public longitude : number = 0;
} 